import { ToggleDisplayComponent } from './toggle-display.component';

export default angular
  .module('sfMobile.components.toggle-labels', [])
  .component('sfToggleLabels', ToggleDisplayComponent).name;
